import apiClient from '../axiosConfig';
import { 
  PublicCarControllerApi, 
  CarControllerApi, 
  CarImageControllerApi,
  CarDto, 
  Car,
  PaginatedResponseCar,
  PaginatedRequest,
  CarImageDto
} from '../../apiClient';

// Initialize APIs
const publicCarApi = new PublicCarControllerApi(undefined, undefined, apiClient);
const adminCarApi = new CarControllerApi(undefined, undefined, apiClient);
const carImageApi = new CarImageControllerApi(undefined, undefined, apiClient);

export const CarService = {
  getPaginated: async (page = 0, size = 10, filters = {}): Promise<PaginatedResponseCar> => {
    // Construct PaginatedRequest
    // Assuming 'filters' contains the partial request object (filters, sorters)
    const request: PaginatedRequest = {
      page,
      pageSize: size,
      ...filters
    };
    
    // Call Public API
    const response = await publicCarApi.getPaginated({ paginatedRequest: request });
    return response.data;
  },

  getById: async (id: string): Promise<CarDto> => {
    // Call Public API
    const response = await publicCarApi.get({ id });
    return response.data;
  },

  create: async (car: CarDto): Promise<string> => {
    // Call Admin API
    const response = await adminCarApi.create1({ carDto: car });
    return response.data;
  },

  update: async (id: string, car: CarDto): Promise<CarDto> => {
    // Call Admin API
    const response = await adminCarApi.update({ id, carDto: car });
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    // Call Admin API
    await adminCarApi._delete({ id });
  },
  
  favorite: async (id: string): Promise<void> => {
     // Call Admin API
     await adminCarApi.favorite({ id });
  }, 

  getFavorites: async (): Promise<CarDto[]> => {
      const response = await adminCarApi.getFavorite();
      return response.data;
  },

  getLatest: async (): Promise<CarDto[]> => {
    const response = await publicCarApi.getLatest();
    return response.data;
  },

  // Image Management Methods
  uploadImage: async (carId: string, file: File, setPrimary: boolean = false): Promise<any> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('setPrimary', setPrimary.toString());

    // Keeping manual implementation for upload because generated code often struggles with multipart/form-data
    return apiClient.post(`/api/v1/car/${carId}/image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  getImages: async (carId: string): Promise<CarImageDto[]> => {
    const response = await carImageApi.getCarImages({ carId });
    return response.data;
  },

  deleteImage: async (imageId: string): Promise<void> => {
    await carImageApi.deleteImage({ imageId });
  },

  setPrimaryImage: async (imageId: string): Promise<void> => {
    await carImageApi.setPrimaryImage({ imageId });
  }
};
